<template>
    <section class="layout">
        <!-- <download-file :isShowDownloadIcon="true" title="子账号管理指引.pdf" uatId="166808e03a5212bd41cfb3b4aa881d05" proId="166809cceb2a2fa4470ebc64ca299737"></download-file> -->
        <div class="header-bar">
            <Row>
                <Col span="4">
                    <m-button v-if="enableEdit" style="width: 80px;" type="primary" @click="add">{{$t('subAccountManagement.t1')}}</m-button>
                </Col>
                <Col span="8" :offset="enableEdit ? 12 : 16">
                    <m-input v-model="value3">
                        <m-select v-model="select3" slot="prepend" style="width: 80px;">
                            <Option value="description">{{$t('subAccountManagement.t2')}}</Option>
                            <Option value="userName">{{$t('subAccountManagement.t3')}}</Option>
                        </m-select>
                        <m-button slot="append" @click="handleSearch" icon="android-search"></m-button>
                    </m-input>
                </Col>
            </Row>
        </div>
        <div class="wrapper">
            <Table border :loading="loading" :columns="columns1" :data="data1" size="small"></Table>
            <m-pagination :showElevator="true" :showSizer="true" :currentPage="currentPage" :pageSize="pageSize" :total="total" :pageSizeOpts="pageSizeOpts" @on-page-size-change="onPageSizeChange" @on-current-page-change="onCurrentPageChange"></m-pagination>
        </div>
        <Modal v-model="modal1" :width="800" :mask-closable="false" @on-cancel="handleCancel">
            <h3 slot="header" class="clearfix">
               <span class="pull-left" style="line-height: 45px;font-size: 16px;">{{$t('subAccountManagement.t4')}}</span>
               <div class="step-header">
                   <div class="step-bar">
                       <div class="step-bar-active" id="step-bar-active"></div>
                   </div>
                    <ul>
                        <li class="active"><span></span><p>{{$t('subAccountManagement.t5')}}</p></li>
                        <li v-if="current >= 1" class="active"><span></span><p>{{$t('subAccountManagement.t6')}}</p></li>
                        <li v-else ><span></span><p>{{$t('subAccountManagement.t6')}}</p></li>
                        <li v-if="current >= 2" class="active"><span></span><p>{{$t('subAccountManagement.t7')}}</p></li>
                        <li v-else ><span></span><p>{{$t('subAccountManagement.t7')}}</p></li>
                        <!-- <li v-if="current >= 3" class="active"><span></span><p>访问组织</p></li>
                        <li v-else ><span></span><p>访问组织</p></li> -->
                        <li v-if="current >= 3" class="active"><span></span><p>{{$t('subAccountManagement.t8')}}</p></li>
                        <li v-else ><span></span><p>{{$t('subAccountManagement.t8')}}</p></li>
                    </ul>
                </div>
            </h3>
            <div v-if="current === 0" class="step-container" style="padding-bottom: 70px;">
                <MForm ref="formItem1" :model="formItem1" label-position="top" :label-width="140">
                    <FormItem prop="subType" :label="$t('subAccountManagement.t9')" :rules="{required: true, message: $t('subAccountManagement.t10')}">
                        <RadioGroup v-model="formItem1.subType" style="font-weight: bold;">
                            <Radio :label="1" style="margin-right: 150px;">{{$t('subAccountManagement.t11')}}</Radio>
                            <Radio :label="0">{{$t('subAccountManagement.t12')}}</Radio>
                        </RadioGroup>
                    </FormItem>
                </MForm>
                <p class="required form-item1-tip">{{$t('subAccountManagement.t13')}}</p>
                <p class="read-checkbox"><Checkbox v-model="readCheckBox"></Checkbox>{{$t('subAccountManagement.t14')}}<a href="javascript:void(0)" @click="downloadFile">《{{$t('subAccountManagement.t15')}}》</a>{{$t('subAccountManagement.t16')}}</p>
            </div>
            <div v-else-if="current === 1" class="step-container">
                <p class="form-item-tip">{{$t('subAccountManagement.t17')}}</p>
                <MForm ref="formItem2" :model="formItem2" :label-width="80">
                    <Row>
                        <Col span="12">
                            <FormItem prop="country" :label="$t('subAccountManagement.t18')" :rules="{required: true, message: $t('subAccountManagement.t19'), trigger: 'blur'}">
                                <Select v-model="formItem2.country" style="width:100%" @on-change="countryChange">
                                    <Option v-for="(item, key) in CUX_COUNTRY" :value="item.label" :label="item.value" :key="key"></Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem prop="description" :label="$t('subAccountManagement.t2')" :rules="{required: true, message: $t('subAccountManagement.t20'), trigger: 'blur'}">
                            <m-input type="text" v-model="formItem2.description">
                            </m-input>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem prop="userName" :label="$t('subAccountManagement.t3')">
                            <m-input type="text" readonly v-model="formItem2.userName">
                            </m-input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="12">
                        <FormItem prop="phone" :label="$t('subAccountManagement.t21')" :rules="[{required: true, message: $t('subAccountManagement.t22'), trigger: 'blur'}, {validator: validatePhone, trigger: 'blur'}]">
                            <m-input type="text" v-model="formItem2.phone" @on-blur="handleBlur" :maxlength="phoneLength">
                            </m-input>
                        </FormItem>
                        </Col>
                        <Col span="12">
                            <Row>
                                <Col :span="formItem2.positions === '其他' ? 12 : 24">
                                    <FormItem prop="positions" :label="$t('subAccountManagement.t23')" :rules="{required: true, message: $t('subAccountManagement.t24'), trigger: 'blur'}">
                                        <Select v-model="formItem2.positions" style="width:100%">
                                            <Option v-for="(item, key) in CUX_ACCOUNT_DUTY" :value="item.value" :label="item.label" :key="key"></Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col span="12" v-if="formItem2.positions === '其他'">
                                    <FormItem :label-width="5" prop="positions2" label="" :rules="{required: true, message: $t('subAccountManagement.t24'), trigger: 'blur'}">
                                        <m-input v-if="formItem2.positions === '其他'" type="text" v-model="formItem2.positions2" :maxlength="10">
                                        </m-input>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="12">
                            <FormItem prop="eMail" :label="$t('subAccountManagement.t25')" :rules="[{required: true, message: '邮箱不能为空', trigger: 'blur'},{ type: 'email', message: $t('subAccountManagement.t26'), trigger: 'blur' }]">
                                <m-input type="text" v-model="formItem2.eMail">
                                </m-input>
                            </FormItem>
                        </Col>
                        <!-- <Col span="12">
                            <FormItem prop="telephone" label="座机" :rules="[{required: true, message: '座机不能为空', trigger: 'blur'}, {pattern: /^((\d{3,4})|\d{3,4}-|s)?\d{7,8}$/, message: '座机号码格式不正确', trigger: 'blur'}]">
                                <m-input type="text" v-model="formItem2.telephone">
                                </m-input>
                            </FormItem>
                        </Col> -->
                    </Row>
                    <Row>
                        <Col span="12">
                        <FormItem prop="startDate" :label="$t('subAccountManagement.t27')" :rules="{required: true, type: 'date', message: $t('subAccountManagement.t28'), trigger: 'change'}">
                            <DatePicker type="date" v-model="formItem2.startDate" placement="top"></DatePicker>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem prop="endDate" :label="$t('subAccountManagement.t29')">
                            <DatePicker type="date" v-model="formItem2.endDate" placement="top"></DatePicker>
                        </FormItem>
                        </Col>
                    </Row>
                </MForm>
            </div>
            <div v-else-if="current === 2" class="step-container">
                <p class="form-item-tip">{{$t('subAccountManagement.t31')}}</p>
                <MForm ref="formItem3" :model="formItem3" :label-width="0">
                    <Row type="flex">
                        <Col span="8" style="border-right: 1px solid #ccc;">
                            <FormItem prop="rolePosition" :rules="{required: true, message: $t('subAccountManagement.t32')}">
                                <RadioGroup v-model="formItem3.rolePosition" vertical @on-change="handleChange">
                                    <Radio :label="role.fdKey" :key="index" v-for="(role, index) in roleList">
                                        {{role.fdName}}
                                    </Radio>
                                </RadioGroup>
                            </FormItem>
                        </Col>
                        <Col span="16" style="padding: 20px;">
                            <h3 style="margin-bottom: 20px;">{{jobTitle}}</h3>
                            <p>{{jobDesc}}</p>
                        </Col>
                    </Row>

                </MForm>
            </div>
            <!-- <div v-else-if="current === 3" class="step-container clearfix" style="width: 600px;">
                <p class="form-item-tip">选择账号能访问的美的组织清单</p>
                <Table ref="organizationListTable" @on-selection-change="handleSelectionChange" border :columns="columns2" :data="data2"></Table>
            </div> -->
            <div v-else-if="current === 3" class="step-container" style="width: 600px;">
                <div class="success-info">
                    <p>{{$t('subAccountManagement.t33')}}</p>
                    <p>* {{$t('subAccountManagement.t3')}}</p>
                    <p>* {{$t('subAccountManagement.t34')}}</p>
                    <p>* {{$t('subAccountManagement.t35')}}</p>
                    <p>{{$t('subAccountManagement.t36')}}</p>
                </div>
                <p class="success-tip">{{$t('subAccountManagement.t37')}}</p>
            </div>
            <div slot="footer" style="text-align: center;">
                <m-button v-if="current > 0" @click="prev">{{$t('subAccountManagement.t38')}}</m-button>
                <m-button v-if="current < 3" type="primary" @click="next" :loading="loading">{{$t('subAccountManagement.t39')}}</m-button>
                <m-button v-else type="success" :loading="loading" @click="handleComplete">{{$t('subAccountManagement.t40')}}</m-button>
            </div>
        </Modal>
        <Modal v-model="modal2" :width="800" :mask-closable="false" @on-cancel="handleCancel2">
            <h3 slot="header" class="clearfix">
               <span class="pull-left" style="line-height: 45px;font-size: 16px;">{{title}}</span>
               <div class="step-header" style="width: 225px;">
                   <div class="step-bar" style="width: 125px;">
                       <div class="step-bar-active" id="step-bar-active2"></div>
                   </div>
                    <ul style="width: 450px;">
                        <li class="active"><span></span><p>{{$t('subAccountManagement.t6')}}</p></li>
                        <li v-if="current2 >= 1" class="active"><span></span><p>{{$t('subAccountManagement.t7')}}</p></li>
                        <li v-else ><span></span><p>{{$t('subAccountManagement.t7')}}</p></li>
                        <!-- <li v-if="current2 >= 2" class="active"><span></span><p>访问组织</p></li>
                        <li v-else ><span></span><p>访问组织</p></li> -->
                    </ul>
                </div>
            </h3>
            <div v-if="current2 === 0" class="step-container">
                <p class="form-item-tip">{{$t('subAccountManagement.t41')}}</p>
                <MForm ref="currentRow1" :model="currentRow" :label-width="80">
                    <Row>
                        <Col span="12">
                            <FormItem prop="country" :label="$t('subAccountManagement.t18')" :rules="{required: true, message: $t('subAccountManagement.t19'), trigger: 'blur'}">
                                <Select v-model="formItem2.country" style="width:100%" @on-change="countryChange">
                                    <Option v-for="(item, key) in CUX_COUNTRY" :value="item.label" :label="item.value" :key="key"></Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem prop="description" :label="$t('subAccountManagement.t2')" :rules="{required: true, message: '联系人不能为空', trigger: 'blur'}">
                                <m-input type="text" :disabled="disabled" v-model="currentRow.description">
                                </m-input>
                            </FormItem>
                        </Col>
                        <Col span="12" style="height:65px;">
                            <FormItem prop="userName" :label="$t('subAccountManagement.t3')">
                                <m-input type="text" readonly :disabled="disabled" v-model="currentRow.userName">
                                </m-input>
                                <m-checkbox :disabled="disabled" v-if="currentRow.userName !== '' && currentRow.userName !== null" v-model="currentRow.resetPassword" :true-value="true" :false-value="false">{{$t('subAccountManagement.t42')}}</m-checkbox>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="12">
                            <FormItem prop="phone" :label="$t('subAccountManagement.t21')" :rules="[{required: true, message: $t('subAccountManagement.t22'), trigger: 'blur'}, {validator: validatePhone, trigger: 'blur'}]">
                                <m-input :disabled="disabled" type="text" v-model="currentRow.phone"  @on-blur="handleBlur" :maxlength="phoneLength">
                                </m-input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <Row>
                                <Col :span="currentRow.positions === '其他' ? 12 : 24">
                                    <FormItem prop="positions" :label="$t('subAccountManagement.t23')" :rules="{required: true, message: $t('subAccountManagement.t24'), trigger: 'blur'}">
                                        <Select v-model="currentRow.positions" style="width:100%">
                                            <Option v-for="(item, key) in CUX_ACCOUNT_DUTY" :value="item.value" :label="item.label" :key="key"></Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col span="12" v-if="currentRow.positions === '其他'">
                                    <FormItem :label-width="5" prop="positions2" label="" :rules="{required: true, message: $t('subAccountManagement.t24'), trigger: 'blur'}">
                                        <m-input v-if="currentRow.positions === '其他'" type="text" v-model="currentRow.positions2" :maxlength="10">
                                        </m-input>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="12">
                            <FormItem prop="eMail" :label="$t('subAccountManagement.t25')" :rules="[{required: true, message: $t('subAccountManagement.t26'), trigger: 'blur'},{ type: 'email', message: $t('subAccountManagement.t26'), trigger: 'blur' }]">
                                <m-input :disabled="disabled" type="text" v-model="currentRow.eMail">
                                </m-input>
                            </FormItem>
                        </Col>
                        <!-- <Col span="12">
                            <FormItem prop="telephone" label="座机" :rules="[{required: true, message: '座机不能为空', trigger: 'blur'}, {pattern: /^((\d{3,4})|\d{3,4}-|s)?\d{7,8}$/, message: '座机号码格式不正确', trigger: 'blur'}]">
                                <m-input :disabled="disabled" type="text" v-model="currentRow.telephone">
                                </m-input>
                            </FormItem>
                        </Col> -->
                    </Row>
                    <Row>
                        <Col span="12">
                            <FormItem prop="startDate" :label="$t('subAccountManagement.t27')" :rules="{required: true, type: 'date', message: $t('subAccountManagement.t28'), trigger: 'change'}">
                                <DatePicker :disabled="disabled" type="date" v-model="currentRow.startDate" placement="top"></DatePicker>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem prop="endDate" :label="$t('subAccountManagement.t29')">
                                <DatePicker :disabled="disabled" type="date" v-model="currentRow.endDate" placement="top"></DatePicker>
                            </FormItem>
                        </Col>
                    </Row>
                </MForm>
            </div>
            <div v-else-if="current2 === 1" class="step-container">
                <p class="form-item-tip">{{$t('subAccountManagement.t31')}}</p>
                <MForm ref="currentRow2" :model="currentRow" :label-width="0">
                    <Row type="flex">
                        <Col span="8" style="border-right: 1px solid #ccc;">
                            <FormItem prop="rolePosition" :rules="{required: true, message: $t('subAccountManagement.t32')}">
                                <RadioGroup v-model="currentRow.rolePosition" vertical @on-change="handleChange2">
                                    <Radio :disabled="disabled" :label="role.fdKey" :key="index" v-for="(role, index) in roleList2">
                                        {{role.fdName}}
                                    </Radio>
                                </RadioGroup>
                            </FormItem>
                        </Col>
                        <Col span="16" style="padding: 20px;">
                            <h3 style="margin-bottom: 20px;">{{jobTitle}}</h3>
                            <p>{{jobDesc}}</p>
                        </Col>
                    </Row>

                </MForm>
            </div>
            <!-- <div v-else-if="current2 === 2" class="step-container clearfix" style="width: 600px;">
                <p class="form-item-tip">选择账号能访问的美的组织清单</p>
                <Table ref="organizationListTable" @on-selection-change="handleSelectionChange2" border :columns="columns2" :data="data3"></Table>
            </div> -->
            <div slot="footer" style="text-align: center;">
                <m-button v-if="current2 > 0" @click="prev2">{{$t('subAccountManagement.t38')}}</m-button>
                <m-button v-if="current2 < 1" type="primary" @click="next2" :loading="loading">{{$t('subAccountManagement.t39')}}</m-button>
                <m-button v-if="current2 === 1 && disabled === false" type="primary" @click="handleSave">{{$t('subAccountManagement.t43')}}</m-button>
                <m-button v-if="current2 === 1 && disabled === true" type="primary" @click="handleClose">{{$t('subAccountManagement.t44')}}</m-button>
            </div>
        </Modal>
    </section>
</template>
<script>
import axios from '@/utils/http';
import {formatDateTime} from '@/utils/datetime-format.js';
import mPagination from '@/components/awesome/page/pagination/index';
import moment from 'moment';
export default {
    name: 'subAccountManagement',
    components: { mPagination },
    data() {
            return {
                isNew: false,
                phoneLength: 10,
                readCheckBox: '',
                CUX_ACCOUNT_DUTY: [],
                columns1: [{
                title: this.$t('subAccountManagement.t3'),
                key: 'userName',
                minWidth: 130,
                render: (h, params) => {
                    return h('a',
                        {props: {href: 'javascript:void(0)'},
                        on: {click: () => {
                                    this.disabled = true;
                                    this.currentRow = {};
                                    this.current2 = 0;
                                    this.title = this.$t('subAccountManagement.t45');
                                    var bar = document.querySelector('#step-bar-active2');
                                    bar.style.width = 0 + 'px';
                                    Object.assign(this.currentRow, {...params.row});
                                    if (this.currentRow.startDate !== null && this.currentRow.startDate !== '') {
                                        this.currentRow.startDate = new Date(this.currentRow.startDate);
                                    }
                                    if (this.currentRow.endDate !== null && this.currentRow.endDate !== '') {
                                        this.currentRow.endDate = new Date(this.currentRow.endDate);
                                    }
                                    if (this.currentRow.userName !== '' && this.currentRow.userName !== null) {
                                        this.$set(this.currentRow, 'resetPassword', false);
                                    }
                                    this.modal2 = true;
                                    this.data3 = Object.assign(this.data2);
                                    for (let i in this.data3) {
                                        for (let j in this.currentRow.orgList) {
                                            if (this.currentRow.orgList[j].orgKey === this.data3[i].organizationCode) {
                                               this.data3[i]._checked = true;
                                               this.data3[i]._disabled = true;
                                               break;
                                            } else {
                                                this.data3[i]._checked = false;
                                                this.data3[i]._disabled = true;
                                            }
                                        }
                                    }
                                    this.getRolePosition(Number(this.currentRow.subType), 'roleList2');
                                }
                            }
                        },
                        params.row.userName);
                }
            }, {
                title: this.$t('subAccountManagement.t2'),
                key: 'description',
                minWidth: 80
            }, {
                title: this.$t('subAccountManagement.t23'),
                key: 'positions',
                minWidth: 80
            }, {
                title: this.$t('subAccountManagement.t25'),
                key: 'eMail',
                minWidth: 190
            },
            //  {
            //     title: '座机',
            //     key: 'telephone',
            //     minWidth: 100
            // },
             {
                title: this.$t('subAccountManagement.t21'),
                key: 'phone',
                minWidth: 100
            }, {
                title: this.$t('subAccountManagement.t46'),
                width: 75,
                render: (h, params) => {
                   return h('div', this.vendorCode);
                }
            }, {
                title: this.$t('subAccountManagement.t47'),
                key: 'isMainAccount',
                align: 'center',
                minWidth: 40,
                render: (h, params) => {
                    return h('div', [
                        h('MRadio', {
                            props: {
                               value: params.row.mainType === 'Y' ? 'true' : 'false',
                               label: '',
                               disabled: true,
                               trueValue: 'true',
                               falseValue: 'false'
                            }
                        })
                    ]);
                }
            }, {
                title: this.$t('subAccountManagement.t27'),
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    return h('div', formatDateTime(new Date(params.row.startDate), 'yyyy-MM-dd'));
                }
            }, {
                title: this.$t('subAccountManagement.t29'),
                minWidth: 80,
                render: (h, params) => {
                    if (params.row.endDate === null) {
                        return h('div', '');
                    } else {
                        return h('div', formatDateTime(new Date(params.row.endDate), 'yyyy-MM-dd'));
                    }
                }
            }, {
                title: this.$t('subAccountManagement.t48'),
                key: 'operating',
                align: 'center',
                fixed: 'right',
                minWidth: 50,
                render: (h, params) => {
                    if ((params.row.mainType === 'N' || !params.row.mainType) && this.enableEdit) {
                        return h('Icon', {
                            props: {
                                size: '18',
                                type: 'edit'
                            },
                            style: {
                                cursor: 'pointer'
                            },
                            nativeOn: {
                                click: () => {
                                    this.handleEdit(params.row);
                                }
                            }
                        });
                    } else {
                        return '';
                        // return h('a', {
                        //     attrs: {
                        //         href: 'javascript:void(0)',
                        //         class: 'el-icon-mf mf-pencil-square-o'
                        //     },
                        //     style: {
                        //         fontSize: '20px'
                        //     },
                        //     on: {
                        //         click: () => {
                        //             this.handleEdit(params.row);
                        //         }
                        //     }
                        // });
                    }
                }
            }],
            data1: [],
            columns2: [{
                type: 'selection',
                width: 60,
                align: 'center'
            }, {
                title: '组织列表',
                key: 'organizationName'
            }],
            data2: [],
            data3: [],
            modal1: false,
            modal2: false,
            disabled: false,
            title: '',
            formItem1: {
                subType: 1
            },
            formItem2: {
                userName: '',
                startDate: new Date(),
                endDate: null,
                positions2: '',
                country: 'THA'
            },
            formItem3: {},
            current: 0,
            current2: 0,
            jobTitle: '',
            jobDesc: '',
            value3: '',
            select3: 'userName',
            organizationList: [],
            organizationList2: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            pageSizeOpts: [10, 30, 50, 80],
            roleList: [],
            roleList2: [],
            currentRow: {
                positions2: ''
            },
            vendorCode: '',
            enableEdit: false,
            loading: false,
            lock: false,
            CUX_COUNTRY: []
        };
    },
    watch: {
        modal1 (newVal) {
            if (!newVal) {
                this.$refs.formItem2.resetFields();
            }
        },
        modal2 (newVal) {
            if (!newVal) {
                this.$refs.currentRow1.resetFields();
            }
        }
    },
    methods: {
        next() {
            if (this.current === 0 && !this.readCheckBox) {
                this.$Modal.error({
                    content: '请阅读并同意《隐私协议》内容'
                });
                return false;
            }
            if (this.current === 1 && this.modal1) {
                this.$refs.formItem2.validate((valid) => {
                    if (valid) {
                        // this.nextFn();
                        this.checkMideaEmail();
                    }
                });
            } else {
                    this.nextFn();
            }
        },
        // 检验是否为美的账号 srmpos/vendorAccount/checkMideaEmail   'renxing@Midea.com','renxing@163.com'
        checkMideaEmail(val) {
            this.loading = true;
            let params = {
                emailList: val ? [this.currentRow.eMail] : [this.formItem2.eMail]
            };
            let url = location.origin + '/srmpos/vendorAccount/checkMideaEmail';
            axios.post(url, params).then(resp => {
                this.loading = false;
                let data = resp.data.data;
                if (data.status === 0) {
                    val ? this.next2Fn() : this.nextFn();
                } else {
                    this.$Modal.error({
                        content: data.msg
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        nextFn () {
            var a = this.current + 1;
            if (this.current < 4) {
                if (this.current <= 2) {
                    this.$refs['formItem' + a].validate((valid) => {
                        if (valid) {
                            this.current = this.current + 1;
                            var bar = document.querySelector('#step-bar-active');
                            bar.style.width = this.current * 33.3 + '%';
                            if (this.current === 1) {
                                this.getRolePosition(Number(this.formItem1.subType), 'roleList');
                            }
                        }
                    });
                } else {
                    this.current = this.current + 1;
                    var bar = document.querySelector('#step-bar-active');
                    bar.style.width = this.current * 33.3 + '%';
                }
            }
        },
        prev() {
            if (this.current > 0) {
                this.current = this.current - 1;
                var bar = document.querySelector('#step-bar-active');
                bar.style.width = this.current * 33.3 + '%';
            }
        },
        next2() {
            if (this.current2 === 0 && this.modal2 && this.title !== '查看详情') {
                this.$refs.currentRow1.validate((valid) => {
                    if (valid) {
                        // 判断 司机账号的SJ后面那一串是否和手机号码一致？如果不一致的话，就报错
                        if (this.currentRow.subType === '0' && this.currentRow.userName.toLocaleLowerCase() !== `sj${this.currentRow.phone}`) {
                            this.$Modal.error({
                                content: '手机与账号SJ后的号码必须保持一致'
                            });
                            return false;
                        }
                        // 若失效日期有值则编辑不能为空
                        if (this.data1.find((i) => i.userName === this.currentRow.userName).endDate && !this.currentRow.endDate) {
                            this.$Modal.error({
                                content: this.$t('subAccountManagement.t30')
                            });
                            return false;
                        }
                       // this.next2Fn();
                        this.checkMideaEmail('next2Fn');
                    }
                });
            } else {
                this.next2Fn();
            }
        },
        next2Fn () {
            if (this.current2 < 2) {
                this.current2 = this.current2 + 1;
                var bar = document.querySelector('#step-bar-active2');
                bar.style.width = this.current2 * 125 + 'px';
            }
        },
        prev2() {
            if (this.current2 > 0) {
                this.current2 = this.current2 - 1;
                var bar = document.querySelector('#step-bar-active2');
                bar.style.width = this.current2 * 125 + 'px';
            }
        },
        handleSave() {
            var array = [];
            this.organizationList2.forEach(el => {
                array.push({userName: this.currentRow.userName, orgKey: el.organizationCode, orgValue: el.organizationName});
            });
            if (typeof this.currentRow.startDate !== 'string' && this.currentRow.startDate !== null && this.currentRow.startDate !== '') {
                this.currentRow.startDate = moment(this.currentRow.startDate).format('YYYY-MM-DD');
            }
            if (typeof this.currentRow.endDate !== 'string' && this.currentRow.endDate !== null && this.currentRow.endDate !== '') {
                this.currentRow.endDate = moment(this.currentRow.endDate).format('YYYY-MM-DD');
            }
            this.currentRow.flag = 'U';
            axios.post('/gscapp/subAccountManagement/subAccount/updateGscSysUsers', {
                    orgList: array,
                    vendorCode: this.vendorCode,
                    ...this.currentRow,
                    positions: this.currentRow.positions === '其他' ? this.currentRow.positions2 : this.currentRow.positions
                }).then(resp => {
                    let data = resp.data;
                    if (data.data.code !== '-1') {
                        this.organizationList2 = [];
                        this.currentRow = {};
                        var bar = document.querySelector('#step-bar-active2');
                        bar.style.width = 0 + 'px';
                        setTimeout(() => { this.modal2 = false; }, 500);
                        if (this.select3 !== '') {
                            this.getData({[`${this.select3}`]: this.value3});
                        } else {
                            this.getData();
                        }
                    } else {
                        // this.$Message.error(resp.msg);
                        this.$Modal.error({
                            content: data.data.msg
                        });
                    };
            });
        },
        handleClose() {
            setTimeout(() => {
                this.modal2 = false;
            }, 500);
        },
        handleChange(val) {
           var a = this.roleList.find(el => {
               return el.fdKey === val;
           });
           this.jobTitle = a.fdName;
           this.jobDesc = a.fdDescription;
        },
        handleChange2(val) {
           var a = this.roleList2.find(el => {
               return el.fdKey === val;
           });
           this.jobTitle = a.fdName;
           this.jobDesc = a.fdDescription;
        },
        handleBlur() {
            let obj = this.isNew ? this.$refs.formItem2 : this.currentRow.phone;
            obj.validateField('phone', (msg) => {
                if (msg === '') {
                    this.loading = true;
                    axios.post('/gscapp/subAccountManagement/subAccount/checkAccount', {vendorCode: this.vendorCode, subType: this.formItem1.subType, phone: this.formItem2.phone}).then(resp => {
                        this.loading = false;
                        let data = resp.data;
                        if (data.data.code === '0') {
                            this.$set(this.formItem2, 'userName', data.data.data);
                        } else {
                            this.$Modal.error({
                                content: data.data.data
                            });
                        }
                    })
                    .catch(() => {
                        this.showErrorTips('loading');
                    });
                }
            });
        },
        handleSelectionChange(selection) {
            this.organizationList = selection;
            for (let i in this.data2) {
                for (let j in this.organizationList) {
                    if (this.organizationList[j].organizationCode === this.data2[i].organizationCode) {
                       this.data2[i]._checked = true;
                       break;
                    } else {
                        this.data2[i]._checked = false;
                    }
                }
            }
        },
        handleSelectionChange2(selection) {
            this.organizationList2 = selection;
        },
        handleComplete() {
            var array = [];
            this.organizationList.forEach(el => {
                array.push({userName: this.formItem2.userName, orgKey: el.organizationCode, orgValue: el.organizationName});
            });
            this.formItem2.startDate = moment(this.formItem2.startDate).format('YYYY-MM-DD');
            if (this.formItem2.endDate !== null && this.formItem2.endDate !== '') {
                this.formItem2.endDate = moment(this.formItem2.endDate).format('YYYY-MM-DD');
            }
            this.loading = true;
            axios.post('/gscapp/subAccountManagement/subAccount/addGscSysUsers', {
                flag: 'C',
                ...this.formItem1,
                ...{
                    ...this.formItem2,
                    positions: this.formItem2.positions === '其他' ? this.formItem2.positions2 : this.formItem2.positions
                },
                ...this.formItem3,
                orgList: array,
                vendorCode: this.vendorCode,
                opruser: this.supplierInfo.userName
            }).then(resp => {
                let data = resp.data;
                this.loading = false;
                if (data.data.code !== '-1') {
                    // this.$Message.success(resp.data.msg);
                    this.$Modal.success({
                        content: data.data.msg
                    });
                    this.organizationList = [];
                    this.formItem1 = this.formItem2 = this.formItem3 = {};
                    this.current = 0;
                    this.lock = false;
                    for (let i in this.data2) {
                        this.data2[i]._checked = false;
                    }
                    var bar = document.querySelector('#step-bar-active');
                    bar.style.width = 0 + 'px';
                    setTimeout(() => { this.modal1 = false; }, 500);
                    if (this.select3 !== '') {
                        this.getData({[`${this.select3}`]: this.value3});
                    } else {
                        this.getData();
                    }
                } else {
                    this.$Modal.error({
                        content: data.data.msg,
                        onOk: () => {
                            this.current = 0;
                            var bar = document.querySelector('#step-bar-active');
                            bar.style.width = this.current * 33.3 + '%';
                            this.formItem2.startDate = this.formItem2.startDate ? new Date(this.formItem2.startDate) : '';
                            this.formItem2.endDate = this.formItem2.endDate ? new Date(this.formItem2.endDate) : '';
                        }
                    });
                };
            })
            .catch(() => {
                this.loading = false;
                this.$Modal.error({
                    content: '创建失败，请联系管理员'
                });
            });
        },
        onCurrentPageChange(page) {
            this.currentPage = page;
            this.handleSearch();
        },
        onPageSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.handleSearch();
        },
        getData(params) {
            this.loading = true;
            axios.post('/gscapp/subAccountManagement/subAccount/selectVendorSubAccount', {...params, current: this.currentPage, size: this.pageSize, vendorCode: this.vendorCode}).then(resp => {
                let data = resp.data;
                if (data.success) {
                    this.loading = false;
                    this.total = data.data.total;
                    this.data1 = data.data.list;
                } else {
                    this.loading = false;
                    // this.$Message.error(resp.msg);
                    this.$Modal.error({
                        content: data.msg
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        handleSearch() {
            if (this.select3 !== '') {
                this.getData({[`${this.select3}`]: this.value3});
            } else {
                this.getData();
            }
        },
        handleEdit(params) {
            this.isNew = false;
            /* 国家默认为泰国 */
            params.country = params.country || 'THA';
            if (this.enableEdit) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }
            this.currentRow = {};
            this.current2 = 0;
            this.title = '编辑';
            var bar = document.querySelector('#step-bar-active2');
            bar.style.width = 0 + 'px';
            this.currentRow = {...params};
            if (this.currentRow.startDate !== null && this.currentRow.startDate !== '') {
                this.currentRow.startDate = new Date(this.currentRow.startDate);
            }
            if (this.currentRow.endDate !== null && this.currentRow.endDate !== '') {
                this.currentRow.endDate = new Date(this.currentRow.endDate);
            }
            if (this.currentRow.userName !== '' && this.currentRow.userName !== null) {
                this.$set(this.currentRow, 'resetPassword', false);
            }
            let list = [];
            this.CUX_ACCOUNT_DUTY.map((item) => {
                list.push(item.value);
            });
            if (!list.includes(this.currentRow.positions)) {
                this.currentRow.positions2 = this.currentRow.positions;
                this.currentRow.positions = '其他';
            }
            this.modal2 = true;
            this.organizationList2 = [];
            for (let r in this.currentRow.orgList) {
                this.organizationList2.push({organizationCode: this.currentRow.orgList[r].orgKey, organizationName: this.currentRow.orgList[r].orgValue});
            }
            this.data3 = Object.assign(this.data2);
            for (let i in this.data3) {
                for (let j in this.currentRow.orgList) {
                    if (this.currentRow.orgList[j].orgKey === this.data3[i].organizationCode) {
                       this.data3[i]._checked = true;
                       this.data3[i]._disabled = false;
                       break;
                    } else {
                        this.data3[i]._checked = false;
                        this.data3[i]._disabled = false;
                    }
                }
            }
            this.getRolePosition(Number(this.currentRow.subType), 'roleList2');
        },
        handleCancel2() {
            this.organizationList2 = [];
            this.currentRow = {};
            this.current2 = 0;
            var bar = document.querySelector('#step-bar-active2');
            bar.style.width = 0 + 'px';
        },
        handleCancel() {
            this.lock = true;
        },
        add() {
            this.isNew = true;
            this.modal1 = true;
            if (!this.lock) {
                this.organizationList = this.data2;
                for (let i in this.data2) {
                    this.data2[i]._checked = true;
                }
            } else {
                for (let i in this.data2) {
                    for (let j in this.organizationList) {
                        if (this.organizationList[j].organizationCode === this.data2[i].organizationCode) {
                           this.data2[i]._checked = true;
                           break;
                        } else {
                            this.data2[i]._checked = false;
                        }
                    }
                }
            }
        },
        setFixedThStyle(node) {
            this.$nextTick(() => { // 固定列调整
                this.thHeight = document.querySelector(node + '.m-table-header thead tr th').offsetHeight;
                let r = document.querySelector(node + '.m-table-fixed-right th');
                if (r) {
                    r.style.height = this.thHeight - 1 + 'px';
                }
            });
        },
        queryDictionaryData (code) {
            axios.get(`/gscint/sys/sysParam/queryDictionaryData?dictCode=${code}&isValid=Y`)
            .then((res) => {
                if (res.data.data) {
                    this[code] = res.data.data;
                }
            });
        },
        downloadFile () {
            const hostname = window.environment.isPro ? window.location.hostname : 'gsc.midea.com';
            window.open(`https://${hostname}/gscint/supplierfile/downloadFile?docId=18008ab720b698f09a16be84f1fb4b62`);
        },
        getSubUserInfo (supplierInfo) {
            axios.get('/gscapp/subAccountManagement/subAccount/getSubUserInfo', {
                params: {
                    userName: supplierInfo.userName
                }
            }).then(res => {
                let data = res.data;
                if (data.success) {
                    if (data.data.mainType === 'Y') {
                        this.enableEdit = true;
                    } else {
                        this.enableEdit = false;
                    }
                } else {
                    this.$Modal.error({
                        content: data.msg
                    });
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        getSRMOUListNew () {
            axios.get('/gscapp/lov/getSRMOUListNew?UP=N&SITE=Y&ASL=N').then(res => {
                let data = res.data;
                if (data.success) {
                    let newArr = [];
                    data.data.map((item) => {
                        newArr.push({
                        organizationCode: item.ouCode,
                        organizationName: item.ouName
                        });
                    });
                    this.data2 = newArr;
                } else {
                    this.$Modal.error({
                        content: data.msg
                    });
                }
            });
        },
        getRolePosition (subType, key) {
            /* 海外特殊处理 */
            subType = subType === 1 ? 3 : subType;
            axios.get('/gscapp/subAccountManagement/subAccount/getRolePosition', {
                params: {
                    subType
                }
            })
            .then((res) => {
                let data = res.data;
                if (data.data.code === '0') {
                    if (subType === 3) {
                        /* 过滤非global开头的用户角色 */
                        data.data.data = data.data.data.filter((item) => item.fdKey.indexOf('global_all') === 0);
                    }
                    this[key] = data.data.data;
                } else {
                    this.$Modal.error({
                        content: data.data.msg
                    });
                }
            });
        },
        countryChange (val) {
            this.phoneLength = Number(this.CUX_COUNTRY.find((item) => item.label === val).attribute1 || 11);
        },
        validatePhone (rule, value, callback) {
            if (value.length !== this.phoneLength || !/^[0-9]*$/.test(value)) {
                callback(new Error(`${this.$t('subAccountManagement.t49')}${this.phoneLength}${this.$t('subAccountManagement.t50')}`));
            }
            callback();
        }
    },
    mounted() {
        this.supplierInfo = JSON.parse(localStorage.getItem('supplierInfo'))
        this.vendorCode = this.supplierInfo.vendorCode;
        this.getSubUserInfo(this.supplierInfo);
        this.getSRMOUListNew();
        this.getData();
        this.setFixedThStyle('.layout ');
        this.queryDictionaryData('CUX_ACCOUNT_DUTY');
        this.queryDictionaryData('CUX_COUNTRY');
    }
};
</script>
<style lang="less" scoped>
    .layout {
        background: #FFF;
    }
    .required {
        color: red;
    }

    .form-item1-tip{
        text-align: center;
        margin-top: 40px;
    }

    .form-item-tip{
        margin-bottom: 20px;
    }

    .header-bar {
        padding: 20px;
        border-bottom: 1px solid #efefef;
    }

    .wrapper {
        padding: 20px 10px;
    }
    .step-container{
        width: 700px;
        margin: 0 auto;
        padding:20px 0 0 0;
        .success-info{
            font-weight: 700;
            font-size: 14px;
            padding: 30px 0 50px 0;
            border-bottom: 1px solid #ccc ;
            color: #2A3C59;
        }
        .success-tip{
            font-weight: 600;
            font-size: 12px;
            padding: 15px 0 20px 0;
            color: #666;
        }
    }

    .step-header {
        width: 445px;
        float: right;
        position: relative;
        padding: 0 0 0 30px;
        overflow: hidden;
        margin-right: 10px;
        ul {
            padding: 0;
            width: 650px;
            float: left;
            position: relative;
            li {
                list-style-type: none;
                float: left;
                position: relative;
                width: 125px;
                &.active{
                    span {
                        background: #2d8cf0;
                    }
                    p {
                        color: #333333;
                    }
                }
                p {
                    font-weight: bold;
                    margin-top: 5px;
                    font-size: 13px;
                    color: #999999;
                    float: left;
                    position: relative;
                    left: -50%;
                    text-align: center;
                    width: 125px;
                }
                span {
                    position: relative;
                    height: 20px;
                    width: 20px;
                    border-radius: 10px;
                    background: #ccc;
                    left: -10px;
                    display: block;
                }
            }
        }
    }

    .step-bar {
        width: 375px;
        height: 13px;
        background: #ccc;
        position: absolute;
        border-radius: 12px;
        top: 4px;
        overflow: hidden;
    }

    .step-bar-active {
        width: 0px;
        height: 13px;
        background: #2d8cf0;
    }
    .read-checkbox {
        text-align:center;
        font-size:14px;
        color:red;
        position:relative;
        top:70px;
        a {
            color: red;
        }
    }
</style>
